import { formatInr } from "../utils/formatInr";

function UtilizationBar({ pct, overBudget }) {
  const width = pct == null ? 0 : Math.min(100, Math.max(0, pct));
  const color = overBudget ? "#dc2626" : width > 85 ? "#f59e0b" : "#1272B3";
  return (
    <div style={{ minWidth: 100 }}>
      <div style={{ fontSize: "0.72rem", color: overBudget ? "#dc2626" : "#64748b", marginBottom: 3 }}>
        {pct != null ? `${pct}%` : "—"}
        {overBudget ? " · Over" : ""}
      </div>
      <div style={{ height: 6, borderRadius: 999, background: "#e2e8f0", overflow: "hidden" }}>
        <div style={{ width: `${width}%`, height: "100%", background: color, borderRadius: 999 }} />
      </div>
    </div>
  );
}

export default function BudgetDepartmentBreakdown({ departments = [] }) {
  if (!departments.length) {
    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #e2e8f0",
          borderRadius: 14,
          padding: "20px 18px",
          marginBottom: 16,
          color: "#64748b",
          fontSize: "0.85rem",
        }}
      >
        No department budget submissions yet for this year.
      </div>
    );
  }

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e2e8f0",
        borderRadius: 14,
        overflow: "hidden",
        marginBottom: 16,
        boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
      }}
    >
      <div style={{ padding: "14px 18px", borderBottom: "1px solid #e2e8f0" }}>
        <div style={{ fontWeight: 800, color: "#0f172a" }}>Department-wise allocation</div>
        <div style={{ fontSize: "0.78rem", color: "#64748b", marginTop: 2 }}>
          Approved department budgets and utilisation across the org
        </div>
      </div>
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.82rem", minWidth: 720 }}>
          <thead>
            <tr style={{ background: "#f8fafc", textAlign: "left" }}>
              {["Department", "Dept budget", "Projects", "Common spend", "YTD spend", "Utilisation", "Pending"].map((h) => (
                <th key={h} style={{ padding: "10px 14px", fontSize: "0.7rem", color: "#64748b", fontWeight: 800 }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {departments.map((row) => (
              <tr
                key={row.department}
                style={{
                  borderTop: "1px solid #f1f5f9",
                  background: row.overBudget ? "#fef2f2" : undefined,
                }}
              >
                <td style={{ padding: "12px 14px", fontWeight: 700 }}>{row.department}</td>
                <td style={{ padding: "12px 14px" }}>{formatInr(row.deptTotalBudget)}</td>
                <td style={{ padding: "12px 14px" }}>{formatInr(row.allocatedToProjects)}</td>
                <td style={{ padding: "12px 14px" }}>{formatInr(row.commonDeptSpend)}</td>
                <td style={{ padding: "12px 14px", fontWeight: 600, color: row.overBudget ? "#dc2626" : "#0f172a" }}>
                  {formatInr(row.ytdSpend)}
                </td>
                <td style={{ padding: "12px 14px" }}>
                  <UtilizationBar pct={row.utilizationPct} overBudget={row.overBudget} />
                </td>
                <td style={{ padding: "12px 14px" }}>
                  {row.pendingPlanCount > 0 ? (
                    <span style={{ color: "#b45309", fontWeight: 700 }}>{row.pendingPlanCount}</span>
                  ) : (
                    "—"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
